import { Outlet, NavLink, useLocation } from "react-router-dom";
import { Trophy, Activity, Sun, Moon } from "lucide-react";
import { useTheme } from "@/hooks/use-theme";

const tabs = [
    { to: "/", label: "Subleagues", icon: Trophy, testid: "nav-subleagues" },
];

export default function Layout() {
    const location = useLocation();
    const { theme, toggle } = useTheme();
    return (
        <div className="min-h-screen flex flex-col">
            <header className="pitch-bg border-b relative" style={{ borderColor: "var(--border)" }}>
                <div className="max-w-6xl mx-auto px-6 md:px-10 py-7 flex items-center justify-between flex-wrap gap-4">
                    <NavLink to="/" className="flex items-center gap-3 group" data-testid="logo-link">
                        <div className="w-10 h-10 flex items-center justify-center" style={{ background: "var(--accent)" }}>
                            <Activity size={20} strokeWidth={2.5} style={{ color: "var(--accent-text)" }} />
                        </div>
                        <div className="leading-none">
                            <div className="label-tiny" style={{ color: "var(--accent)" }}>Coach van het Jaar</div>
                            <h1 className="text-2xl md:text-3xl font-heading mt-1">
                                Subleague Tracker
                            </h1>
                        </div>
                    </NavLink>
                    <nav className="flex items-center gap-2" data-testid="primary-nav">
                        {tabs.map((t) => {
                            const Icon = t.icon;
                            const active = location.pathname === t.to || (t.to === "/" && location.pathname.startsWith("/subleague"));
                            return (
                                <NavLink
                                    key={t.to}
                                    to={t.to}
                                    data-testid={t.testid}
                                    className={`flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-[0.18em] font-bold border transition-colors ${
                                        active
                                            ? ""
                                            : "hover:bg-[var(--bg-hover)]"
                                    }`}
                                    style={
                                        active
                                            ? {
                                                  background: "var(--accent)",
                                                  color: "var(--accent-text)",
                                                  borderColor: "var(--accent)",
                                              }
                                            : {
                                                  borderColor: "var(--border)",
                                                  color: "var(--text)",
                                              }
                                    }
                                >
                                    <Icon size={14} strokeWidth={2.5} />
                                    {t.label}
                                </NavLink>
                            );
                        })}
                        <button
                            onClick={toggle}
                            aria-label={theme === "dark" ? "Naar licht thema" : "Naar donker thema"}
                            title={theme === "dark" ? "Licht thema" : "Donker thema"}
                            className="flex items-center justify-center w-9 h-9 border transition-colors hover:bg-[var(--bg-hover)]"
                            style={{ borderColor: "var(--border)", color: "var(--text)" }}
                            data-testid="theme-toggle"
                        >
                            {theme === "dark" ? <Sun size={14} strokeWidth={2.5} /> : <Moon size={14} strokeWidth={2.5} />}
                        </button>
                    </nav>
                </div>
            </header>
            <main className="flex-1 max-w-6xl w-full mx-auto px-6 md:px-10 py-8 md:py-12">
                <Outlet />
            </main>
            <footer className="border-t py-6" style={{ borderColor: "var(--border)" }}>
                <div className="max-w-6xl mx-auto px-6 md:px-10 flex items-center justify-between text-xs uppercase tracking-[0.18em]" style={{ color: "var(--text-dim)" }}>
                    <span>Privé tracker · Eredivisie {new Date().getFullYear()}/{(new Date().getFullYear() + 1).toString().slice(2)}</span>
                    <span className="hidden md:inline">Data van coachvanhetjaar.nl</span>
                </div>
            </footer>
        </div>
    );
}
